import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./App.css";
import Routes from "./Routes";
import { AppContext } from "./libs/contextLib";
import { Auth } from "aws-amplify";
import { loadBusiness, getStampsImageList } from "./services/Business";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { LoaderProvider } from "./context/LoaderContext";

function App() {
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [isAuthenticated, userHasAuthenticated] = useState(false);
    const [business, setBusiness] = useState(null);
    const [stampsImageList, setStampsImageList] = useState([]);
    const history = useHistory();

    useEffect(() => {

    /**
     * Check if session is authenticated
     */
    async function onLoad() {
        try {
            const currentUserInfo = await Auth.currentUserInfo();
            //get the user's business information.  if no business found, show error for nows
            if (currentUserInfo) {
                const business = await loadBusiness();
                if (business && business.enabled === true) {
                    setBusiness(business);

                    //Load the stamp images that will be available for use and just pass it as context for convenience
                    var stampsImageList = await getStampsImageList(business);
                    setStampsImageList(stampsImageList);
                
                    userHasAuthenticated(true);
                } else {
                    //user does not have active business
                    history.push("/logout");
                }
            }
        }
        catch(e) {
            //if error, redirect user back to login page since we cannot process crucial information
            history.push("/logout");
        }
        setIsAuthenticating(false);
    }
        onLoad();
    }, [history, isAuthenticated]);  

    return (
        !isAuthenticating && (
        <div id="App" className="App">
            <Header authenticated={isAuthenticated} />
            <AppContext.Provider
            value={{ isAuthenticated, userHasAuthenticated, business, setBusiness, stampsImageList}}
            >
                <LoaderProvider>
                <Routes />
                </LoaderProvider>
            </AppContext.Provider>
            <Footer/>
        </div>
        )
    );
}

export default App;